<div class="modal">

    <div class="title-row">
        <h3>
            {{'shopping-cart.order' | translate}}
        </h3>

        <span appIcon="close"
              class="close-icon"
              (click)="closeDialog()"
        ></span>
    </div>

    <ng-container *ngIf="localizationService.currentLocale$ | async as locale">
        <div *ngIf="!loading else loadingState"
             class="product"
        >
            <div class="image"
                 *ngIf="product.images | getProductImageOfType: ProductImageTypeEnum.Front as productImage"
            >
                <img [src]="productImage.url"
                     [alt]="productImage.alt"
                     loading="lazy"
                     height="100%"
                     width="100%"
                />
            </div>
            <div class="info">
                <label class="bold stretch uppercase">
                    {{ product.brand ? product.brand.name : product.range }}
                </label>

                <label class="label stretch first-letter-uppercase">
                    {{ product.translations[locale].name }}
                </label>

                <!--TODO:: add the price setting here-->
                <p *ngIf="debtorPrice">
                    € {{debtorPrice.price | priceSplit}}
                </p>
            </div>
        </div>
    </ng-container>

    <div class="input-field">
        <label>
            {{'common.amount' | translate}}
        </label>
        <app-input [control]="amountToOrder"
                   type="number"
                   placeholder="{{ 'orders.amount-of-products' | translate }}"
        ></app-input>
    </div>

    <div class="button-row">
        <app-button theme="dark"
                    layout="icon-label"
                    icon="add-to-cart"
                    size="larger"
                    (click)="orderAgain()"
                    [state]="submitting ? 'loading' : 'default'"
        >
            {{'products.add-to-cart' | translate}}
        </app-button>
    </div>
</div>

<ng-template #loadingState>
    <app-page-spinner></app-page-spinner>
</ng-template>
